import { client } from './index';
import { IShippingInfo, IShippingMethod, IValidateAdminEmailResponse } from '../domains/signup.domain';

const PREFIX = '/signup/';

export const recalculateShipping = (info: IShippingInfo): Promise<IShippingMethod[]> =>
  client.post(`${PREFIX}recalculate-shipping`, info).then(response => response.data);

export const validateAdminEmail = (email: string): Promise<IValidateAdminEmailResponse> =>
  client.post(`${PREFIX}validate-admin-email`, { email }).then(response => response.data);
